// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"063abf2a","453":"da614a5d"}[chunkId] + ".chunk.js";
};